const copy = {
  browseArticlesByProduct: {
    button: {
      viewMoreArticles: (isViewingMore: boolean): string =>
        isViewingMore ? 'View less' : 'View more',
    },
    heading: 'Browse articles by product',
  },
  reactHelmet: {
    title: 'Twilio Help Center',
  },
  productCard: {
    viewMore: 'View more',
  },
  errors: {
    log: 'Unable fetch articles by products due to server error',
  },
  emptyState: {
    oops: {
      heading: "Looks like something isn't working",
      description: "We couldn't find articles. Please try again later",
    },
  },
};

export default copy;
